__webpack_require__.p = "/wp-content/themes/lp-twooca/assets/ring/";